import { v4 } from 'uuid';

export const newId = (): string => v4();
